<template>
    <main id="mainCtrl" v-cloak class="calltrackingList">
        <header class="header-filters">
            <div class="header-filters__group">
                <button style="top: 0" @click="showExportDialog">
                    <img width="25" src="data:image/svg+xml;base64,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">
                    Экспорт
                </button>
                <date-range-picker ref="datepicker" @selected="setCreatePeriodFilter"/>
            </div>
            <div></div>
        </header>
        <ExportDialog ref="export"></ExportDialog>
        <v-table id="table"
                 request-uri="calltracking/getList"
                 pagination-uri="calltracking/tableMeta"
                 pagesize="50"
                 ref="table"
                 :lazycount="true"
                 :default-filter="{createdPeriod: '-2 days | today'}"
                 @clear-table-filter="clearPlaceholder"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="clinicCity" width="50">
                        Город
                    </v-th>
                    <v-th name="callkeeper_id" width="70">
                        №
                    </v-th>
                    <v-th name="orderDate" sort="orderDate" width="60" align="center">
                        Создан
                    </v-th>
                    <v-th name="filelength" sort="filelength" width="50" tooltip="Длительность">
                        Длит
                    </v-th>
                    <v-th name="clinicName" minwidth="130">
                        Название клиники
                    </v-th>
                    <v-th name="phone" sort="phone" width="120">
                        Тел пациента
                    </v-th>
                    <v-th name="filename" minwidth="270">
                        Запись разговора
                    </v-th>
                    <v-th name="callkeeper_service_type" sort="callkeeper_service_type" width="150">
                        Тип звонка
                    </v-th>
                    <v-th name="status" width="50">
                        Статус
                    </v-th>
                    <v-th name="status_description" width="200">
                        Описание статуса
                    </v-th>
                    <v-th name="manager" width="80">
                        Менеджер
                    </v-th>
                    <v-th name="callkeeper_referrer" width="120">
                        Источник
                    </v-th>
                    <v-th name="provider" width="120">
                        Провайдер
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="clinicCity" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options='[
                                        {
                                            value: "",
                                            text: "\u00a0"
                                        },
                                        ...cityOptions
                                  ]'/>
                    </v-th>
                    <v-th name="callkeeper_id" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="orderDate" v-slot="{filter}">
                        <date-piker
                            :format="'YYYY-MM-DD'"
                            v-model="filter.value"
                            ref="singleDate"
                            @change="clearDateRangePicker"
                        />
                    </v-th>
                    <v-th name="filelength" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "0",
                                    text: "0 сек"
                                },
                                {
                                    value: "< 45",
                                    text: "<45 сек"
                                },
                                {
                                    value: ">= 45",
                                    text: "≥45 сек"
                                },
                                {
                                    value: ">= 300",
                                    text: "≥5 мин"
                                },
                                {
                                    value: ">= 600",
                                    text: "≥10 мин"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="clinicName" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="phone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="filename" v-slot="{filter}">
                        <input disabled>
                    </v-th>
                    <v-th name="callkeeper_service_type" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "calltracking",
                                    text: "Статический коллтрекинг"
                                },
                                {
                                    value: "callback",
                                    text: "Обратный звонок"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="status" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "200/200",
                                    text: "Успешный"
                                },
                                {
                                    value: "STATUS_FAIL",
                                    text: "Не успешный"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="status_description" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...descriptionStatuses
                            ]'
                        />
                    </v-th>
                    <v-th name="manager" v-slot="{filter}">
                        <v-select
                            @open="scrollTableToEnd"
                            v-model="filter.value"
                            :options='[
                                {
                                    text: "\u00a0",
                                    value: ""
                                },
                                {
                                    value: "*",
                                    text: "Любой"
                                },
                                {
                                    value: "-",
                                    text: "- Нет"
                                },
                                ...userOptions.map(item => {
                                    return {
                                        value: item.id,
                                        text: item.fio + " - " + item.login + "(" + item.params.report.emailLogin + ")"
                                    };
                                })
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="callkeeper_referrer">
                        <input type="text" disabled>
                    </v-th>
                    <v-th name="provider" v-slot="{filter}">
                        <v-select
                            @open="scrollTableToEnd"
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "CALLKEEPER",
                                    text: "Callkeeper"
                                },
                                {
                                    value: "CALLTOUCH",
                                    text: "Calltouch"
                                },
                            ]'
                        />
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{item, index}">
                <v-tr style="cursor: default">
                    <v-td name="clinicCity">
                        <template v-for="(city, i) in item.clinicCities.split(',')">
                            <template v-if="cityOptions.find(el => el.value === city)">
                                <span>{{ cityOptions.find(el => el.value === city).textAbbr }}</span>
                                <br v-if="(i + 1) < item.clinicNames.split('∴').length">
                            </template>
                        </template>
                    </v-td>
                    <v-td name="callkeeper_id">
                        {{ item.callkeeper_id }}
                    </v-td>
                    <v-td name="orderDate">
                        <div>{{ item.orderDate | formatDateShort }}</div>
                        <div>{{ item.orderTime | formatTime }}</div>
                    </v-td>
                    <v-td name="filelength" align="right">
                        {{ item.filelength | formatDuration }}
                    </v-td>
                    <v-td name="clinicName">
                        <template v-for="(clinicName, i) in item.clinicNames.split('∴')">
                            <span>{{ clinicName }}</span>
                            <br v-if="(i + 1) < item.clinicNames.split('∴').length">
                        </template>
                    </v-td>
                    <v-td name="phone">
                        {{ item.phone }}
                    </v-td>
                    <v-td name="filename" align="center">
                        <audio preload="none" v-if="item.audioIsPlayable" controls :src="item.callkeeper_file_url"></audio>
                        <span v-else> - </span>
                    </v-td>
                    <v-td name="callkeeper_service_type">
                        {{ item.callkeeper_service_type }}
                    </v-td>
                    <v-td name="status" align="center">
                        <i v-if="item.status.status" :style="{color: item.status.color}" class="fa-solid fa-check"></i>
                        <i v-else :style="{color: item.status.color}" class="fa-solid fa-ban"></i>
                    </v-td>
                    <v-td name="status_description">
                        {{ item.status_description }}
                    </v-td>
                    <v-td name="manager" highlight="*" align="center">
                        <template v-for="(manager, i) in item.managers">
                            <del v-if="manager.deleted_at">
                                <span v-tooltip="manager.fio">
                                    {{ manager.fioInitials }}
                                </span>
                            </del>
                            <span v-else v-tooltip="manager.fio">
                                {{ manager.fioInitials }}
                            </span>
                          <br v-if="(i + 1) < item.managers.length">
                        </template>
                        <template v-if="!item.managers.length">
                            -
                        </template>
                    </v-td>
                    <v-td name="callkeeper_referrer">
                        {{ item.callkeeper_referrer }}
                    </v-td>
                    <v-td name="provider">
                        <span v-if="item.provider === 'CALLKEEPER'">Callkeeper</span>
                        <span v-else-if="item.provider === 'CALLTOUCH'">Calltouch</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import ExportDialog from "../../../components/dialogs/admin/orders/calltracking/ExportDialog";
import { scrollTableToEnd } from "@/global/helpers";

export default {
    name: "Calltracking",
    components: {ExportDialog},
    props: {
        cityOptions: { type: Array, required: true },
        descriptionStatuses: { type: Array, required: true },
        userOptions: { type: Array, required: true },
    },
    data() {
        return {
            scrollTableToEnd: scrollTableToEnd,
        }
    },
    methods: {
        setCreatePeriodFilter(data) {
            if (this.isTableLoaded()) {
                if (data) {
                    this.$refs.table.$data.filter.createdPeriod = data;
                    if (this.$refs.singleDate) {
                        this.$refs.singleDate.$refs.popup.clear();
                    }
                } else {
                    delete this.$refs.table.$data.filter.createdPeriod;
                }
                this.$refs.table.update();
            }
        },
        isTableLoaded() {
            return this.$refs?.table !== undefined;
        },
        showExportDialog() {
            this.$refs.export.open()
        },
        clearDateRangePicker() {
            if (this.$refs.singleDate.date && this.$refs.datepicker.end) {
                delete this.$refs.datepicker.clearRange();
            }
        },
        clearPlaceholder() {
            if (this.$refs.singleDate.date) {
                this.$refs.datepicker.clearRange()
            } else {
                this.$refs.datepicker.placeholder = 'lastThreeDays';
                this.$refs.datepicker.setPlaceholderDateToInput();
            }
        },
        handleAudioListener(e) {
            let audios = document.getElementsByTagName('audio');

            for(let i = 0; i < audios.length; i++) {
                if(audios[i] !== e.target) {
                    audios[i].pause();
                }
            }
        }
    },
    mounted: function () {
        document.addEventListener('play', this.handleAudioListener, true);
    },
    destroyed: function () {
        document.removeEventListener('play', this.handleAudioListener, true);
    }
}
</script>

<style scoped lang="scss">
.header-filters {
    display: flex;
    justify-content: space-between;
    &__group {
        display: flex;
        button {
            margin-right: 1rem;
        }
    }
}
audio {
    height: 40px;
    width: 100%;
}
</style>
